import React from 'react';
import { InputNumber } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class DoubleEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {

        return (
            <InputNumber
                style={{ width: '100%' }}
                value={this.props.source.value}
                precision={this.props.source.precision !== undefined ? this.props.source.precision : undefined}
                min={this.props.source.minValue === undefined ? Number.MIN_SAFE_INTEGER : this.props.source.minValue}
                max={this.props.source.maxValue === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValue}
                onChange={e => this.onChange(e)} />
        );
    }
}

PropertyGridUtils.register("double", (source, propertyGrid) => <DoubleEditor source={source} propertyGrid={propertyGrid} />);